import Vue from 'vue'
import VueRouter from 'vue-router'
import NavigationPage from '../components/NavigationPage.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: { name: 'activityHome' }
  },
  {
    path: '/painting',
    name: 'painting',
    component: NavigationPage,
    children: [
      {
        path: 'activityHome',
        name: 'activityHome',
        meta: {
          title: '活动'
        },
        component: () => import('../views/ActivityHome/ActivityHome.vue')
      },
      {
        path: 'signupPage',
        name: 'signupPage',
        meta: {
          title: '报名'
        },
        component: () => import('../views/SignupPage/SignupPage.vue')
      },
      {
        path: 'previousWorks',
        name: 'previousWorks',
        meta: {
          title: '往期作品'
        },
        component: () => import('../views/PreviousWorks/PreviousWorks.vue')
      },
      {
        path: 'listofWorks',
        name: 'listofWorks',
        meta: {
          title: '作品列表'
        },
        component: () => import('../views/ListofWorks/ListofWorks.vue')
      }
    ]
  }
]

const router = new VueRouter({
  // mode: 'history',
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  }
})
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

const originalPush = VueRouter.prototype.push
// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default router
